export default function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
// module id = WKzt
// module chunks = 0